import {Dialog, DialogContent, Grid, IconButton, styled, Typography} from "@mui/material";
import { Alert } from '@mui/material';
import {Close} from "@mui/icons-material";

const StyledAlert = styled(Alert)(() => ({
    "& .MuiAlert-icon": {
        padding: "3px 0 0 0",
    },
    "& .MuiAlert-message": {
        padding: "0px",
        width: "100%"
    }
}));

interface EnhancedErrorDialogProps {
    open?: boolean;
    onClose?: () => void;
    errorHeader?: any;
    errorMessage?: any;
    errorActions?: any;
    [key: string]: any;
}

function EnhancedErrorDialog(props: EnhancedErrorDialogProps) {
    return (
        <Dialog open={props.open === undefined ? false : props.open} onClose={props.onClose} style={{padding: 0}}>
            <DialogContent style={{padding: 0}}>
                <StyledAlert style={{
                    padding: "6px 6px",
                    whiteSpace: 'pre-line',
                    textAlign: "left",
                    minWidth: "250px",
                    minHeight: "100px"
                }} severity="error">
                    <Grid container style={{width: "100%"}}>
                        <Grid item container style={{width: "100%"}}>
                            <Typography variant={"h6"}>{props.errorHeader}</Typography>
                            <IconButton
                                onClick={props.onClose}
                                style={{marginLeft: "auto", height: "22px", width: "22px"}}
                                size="large">
                                <Close style={{fontSize: "22px", marginLeft: "auto"}}/>
                            </IconButton>
                        </Grid>
                        <Typography variant={"body1"}>{props.errorMessage}</Typography>
                        {props.errorActions}
                    </Grid>
                </StyledAlert>
            </DialogContent>
        </Dialog>
    );
}

export default EnhancedErrorDialog;
